import NuclearNoteManage from "./nuclear_note_manage";

export default NuclearNoteManage;
